import { cva } from 'class-variance-authority';

export const cardVariants = cva(
  [
    '[&>svg]:fill-current',
    'flex',
    'flex-col',
    'min-w-min',
    'text-color-ref-text-muted',
    'rounded-radius-sys-radius-8',
  ],
  {
    variants: {
      variant: {
        filled: ['bg-color-comp-card-container-enabled'],
        outlined: [
          'border-2',
          // "color.comp.action.primary.plain.border.enabled
          'border-color-comp-accordion-outline-stroke-default',
          'data-[disabled]:border-color-comp-accordion-outline-stroke-disabled',
        ],
        outlineFilled: [
          'rounded-radius-ref-large',
          'border-2',
          'border-color-ref-ui-divider-strong',
          'bg-color-ref-ui-surface-base',
        ],
      },
      clickable: {
        true: ['cursor-pointer', 'transition', 'ease-in-out'],
        false: [],
      },
      noBorder: {
        bottom: 'rounded-b-none',
        left: 'rounded-l-none',
        right: 'rounded-r-none',
        top: 'rounded-t-none',
      },
    },
    compoundVariants: [
      {
        clickable: true,
        variant: 'filled',
        className: ['hover:bg-color-comp-card-container-hover'],
      },
      {
        clickable: true,
        variant: 'outlined',
        className: ['hover:border-color-comp-accordion-outline-stroke-hover'],
      },
    ],
    defaultVariants: {
      variant: 'filled',
      clickable: false,
    },
  },
);
